
export const WorkItemSearchStatuses = [
    { id: 2, name: 'In Progress' },
    { id: 3, name: 'On Hold' },
    { id: 6, name: 'Cancelled' }
];

export const WorkItemStatuses = [
    { value: 1, label: 'Upcoming' },
    { value: 2, label: 'In Progress' },
    { value: 3, label: 'On Hold' },
    { value: 4, label: 'Pending' },
    { value: 5, label: 'Completed' },
    { value: 6, label: 'Cancelled' },
];

export const WorkItemStatusValidTransitions: { fromStatus: number, toStatus: number, supportedByBulk: boolean }[] = [
    //TODO in BFLY-10351 story, this needs to come from backend
    { fromStatus: 2, toStatus: 3, supportedByBulk: true },//Inprogress -> Onhold
    { fromStatus: 2, toStatus: 6, supportedByBulk: true }, //Inprogress -> Cancelled
    { fromStatus: 3, toStatus: 2, supportedByBulk: true },//Onhold -> Inprogress
    { fromStatus: 6, toStatus: 2, supportedByBulk: true }//Cancelled -> Inprogress
]

export const WorkItemBulkUpdateStatuses = WorkItemStatusValidTransitions
    .filter(transition => transition.supportedByBulk)
    .flatMap(transition => [transition.fromStatus, transition.toStatus])
    .reduce((acc: number[], value) => {
        if (!acc.includes(value)) {
            acc.push(value);
        }
        return acc;
    }, [])
    .map(value => {
        const supportedBulkUpdateStatus = WorkItemStatuses.find(status => status.value === value);
        if (supportedBulkUpdateStatus) {
            return { id: supportedBulkUpdateStatus.value, name: supportedBulkUpdateStatus.label };
        }
        return null;
    })
    .filter(status => status !== null);